// extracted by mini-css-extract-plugin
module.exports = {"link":"navigation_link__DJxn0","icon":"navigation_icon__kFBw1","item":"navigation_item__c1LeO","linkIcon":"navigation_linkIcon__7qCXc"};